// extracted by mini-css-extract-plugin
export var locationWrapper = "locationStyles-module--locationWrapper--anJ3B";